module.exports = __webpack_public_path__ + "img/entegre.cdaabc9b.png";